
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tentang-aplikasi",
      function () {
        return require("private-next-pages/tentang-aplikasi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tentang-aplikasi"])
      });
    }
  